SessionStorageService.$inject = [
  'UserSessionStorageService'
];

export function SessionStorageService(UserSessionStorageService) {
  'use strict';
  function deprecated(fn) {
    //SessionStorageService used the html5 sessionStorage which was misunderstood.
    //since 10.8.2017 this error was corrected and the service renamed to avoid confusion.
    //old Service (if ever required) may be retrieved from commit 2764da62cd.
    //this is left here to check for it's usage.
    console.warn(
      'DEPRECATED: Use UserSessionStorageService instead (found in ' +
      window.location.hash +
      ')'
    );
    return fn;
  }
  return {
    clearSession: deprecated(UserSessionStorageService.clearSession),
    /** create a named storage object */
    createStorage: deprecated(UserSessionStorageService.createStorage)
  };
}
